<template>
    <section>
        <sui-table width="100%" :color="color" :class="{selectable: navigate.value}">
            <sui-table-header>
                <sui-table-row v-show="activeSearch">
                    <sui-table-header-cell class="txtc" :colspan="headers.length">
                        <slot name="search"/>
                    </sui-table-header-cell>
                </sui-table-row>
                <sui-table-row>
                    <sui-table-header-cell
                        v-for="(header, index) in headers"
                        :key="index"
                        :class="header.class ? header.class: ''"
                    >
                        <span v-if="useUppercaseInHeaders">{{ header.name | uppercase }}</span>
                        <span v-else>{{ header.name }}</span>
                    </sui-table-header-cell>
                </sui-table-row>
            </sui-table-header>
            <sui-table-body>
                <sui-table-row v-if="$parent.records.length === 0">
                    <sui-table-cell textAlign="center" :colspan="headers.length"><strong>No se encontraron registros</strong></sui-table-cell>
                </sui-table-row>
                <sui-table-row v-for="(item, index) in $parent.records" :key="index" @click="onNavigate(item)" :class="navigate.value ? 'clickable highlightrow' : ''">
                    <sui-table-cell
                        @click="(header.navigate && item[header.key] && item[header.key][header.value]) && onNavigate(item, header)"
                        v-for="(header, indexHeader) in headers"
                        :key="indexHeader"
                        :class="[header.cellclass, (header.navigate && header.navigate.value && item[header.key] && item[header.key][header.value]) ? 'clickable highlightrow' : '']"
                        :width="header.width ? header.width : 2"
                    >

                        <span v-if="header.type === 'object'"> {{ (item[header.key] && item[header.key][header.value] ? item[header.key][header.value] : 'Indefinido') | dynamicFilter(header.filter) }}</span>
                        <slot :name="header.slotName" v-else-if="header.type === 'slot'" :item="item"/>
                        <span v-else-if="header.type === 'currency'">{{ item[header.value] | currency }}</span>
                        <span v-else-if="header.type === 'date'">{{ item[header.value] | date }}</span>
                        <span v-else-if="header.type === 'dateShort'">{{ item[header.value] | dateShort }}</span>
                        <span v-else-if="header.type === 'percentage'">{{ item[header.value] | percentage(header.decimals, header.base) }}</span>
                        <span v-else-if="header.type === 'button'">
                            <sui-button positive size="mini" @click="$parent.processFunction(header.callback, item.id)">{{header.value}}</sui-button>
                        </span>
                        <span v-else-if="header.type === 'function'">{{ $parent.processFunction(header.callback, item) }}</span>
                        <span v-else-if="header.type === 'renderOption' ">
                            {{ Utils.displayOptionName(header.options, item[header.value]) }}
                        </span>
                        <span v-else-if="header.type === 'template'">
                            <div v-if="header.value === 'status'">
                                <h4 is="sui-header" :color="displayCreditStatusName(item[header.value]).color">{{displayCreditStatusName(item[header.value]).name}}</h4>
                            </div>
                            <div v-else-if="header.value === 'daysOverDue'">
                                <h6 is="sui-header" :color="displayIsDelayed(item[header.value]).color">{{displayIsDelayed(item[header.value]).name}}</h6>
                            </div>
                        </span>
                        <div v-else-if="header.type === 'popup'" class="ui icon">
                            <i class="large icon" :class="header.classTooltip || 'comments gray'"
                                v-tooltip.top-center
                                v-tooltip="{ content: item[header.value]}"
                                v-if="item[header.value] && !Utils.isObjectEmpty(item[header.value])">
                            </i>
                        </div>
                        <span v-else>{{ item[header.value] }}</span>
                    </sui-table-cell>
                </sui-table-row>
            </sui-table-body>
            <sui-table-footer>
                <sui-table-row >
                    <sui-table-header-cell :colspan="headers.length" text-align="right">
                        <Pagination :total="$parent.total" :page-size="$parent.searchRecord.pageSize" :callback="callback"/>
                    </sui-table-header-cell>
                </sui-table-row>
            </sui-table-footer>
        </sui-table>
    </section>
</template>

<script>

import Pagination from '@/components/Helpers/Pagination.vue'
import Mixins from '@/mixins/index.js'

export default {
    name: 'GenericPaginatedList',
    emits: ['navigate'],
    props: {
        // Para detalle
        recordName: {
            type: String,
            required: false
        },
        color: {
            type: String,
            default: 'blue'
        },
        useUppercaseInHeaders: {
            type: Boolean,
            default: true
        },
        activeSearch: {
            type: Boolean,
            default: false
        },
        navigate: {
            type: Object,
            default: () => Object.assign({
                value: false,
                blank: false,
                customNavigate: false,
                customName: '',
                customId: '',
                customGoTo: ''
            })
        },
        headers: {
            type: Array,
            default: () => []
        },
        callback: {
            type: Function,
            required: false
        }
    },
    components: { Pagination },
    mixins: [ Mixins ],

    methods: {
        onNavigate (item, header = null) {
            const navigate = (header && header.navigate) ? header.navigate : this.navigate

            if (navigate.emits) {
                this.$emit('navigate', item, navigate)
            } else if (navigate.customNavigate) {
                if (item[navigate.customId]) {
                    if (navigate.blank) this.newTabTo(item[navigate.customId].id, navigate.customName, navigate.customGoTo)
                    else this.navigateTo(item[navigate.customId].id, navigate.customName, navigate.customGoTo)
                }
            } else if (navigate.value) {
                if (navigate.blank) this.newTabTo(item.id)
                else this.navigateTo(item.id)
            }
        }
    }
}
</script>

<style scoped>
    .ui.table thead {
        top: 0;
        z-index: 2;
        position: sticky !important;
    }
</style>
